import { render } from "./NotasTables.vue?vue&type=template&id=1b901e7b"
import script from "./NotasTables.vue?vue&type=script&lang=js"
export * from "./NotasTables.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__